import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import ProfilePanel from "../../components/ProfilePanel/ProfilePanel";
import ProfileSideBar from "../../components/ProfileSideBar/ProfileSideBar";
import { emptyCart, removeUser } from "../../Redux/Actions";
import salonImage from "../../assets/images/11.png";
import "./Profile.scss";
import "./Responsive.scss";
import { Config } from "../../Config";

const Profile = (props) => {
  const [panelPage, setPanelPage] = useState("userInfo");
  const [panelData, setPanelData] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [oilQuota, setOilQuota] = useState(null);
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  useEffect(async () => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0].token}`);

    fetch(Config.apiPath + "/orderApi/getUserOrders", {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${user[0].token}`,
      },
    })
      .then((response) => response.json())
      // .then((result) => setorderHistory(result.profileImage));
      .then((result) => setOrderHistory(result));
    // -------------------------------------------------------------------------------
    fetch(Config.apiPath + "/account/getProfile", {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${user[0].token}`,
      },
    })
      .then((response) => response.json())
      .then((result) => setProfileImage(result.profileImage));
    // -------------------------------------------------------------------------------
    fetch(Config.apiPath + "/account/userOilQuota", {
      method: "GET",
      headers: myHeaders,
    }).then(async (response) => {
      if (response.status === 200) {
        let resJson = await response.json();
        setOilQuota(resJson.data);
      }
    });
  }, []);

  useEffect(() => {
    if (user.length <= 0) {
      props.history.push("/login");
    }
  }, [user.length <= 0]);

  const sideBarActions = (e, type) => {
    const sideBarItems = document.querySelectorAll(".sideBarItem");
    for (let i = 0; i < sideBarItems.length; i++) {
      sideBarItems[i].classList.remove("active");
      sideBarItems[i].classList.remove("needBefore");
    }
    e.target.classList.add("active");
    e.target.classList.add("needBefore");
    switch (type) {
      case "logout":
        setPanelPage("logout");
        if (dispatch(removeUser(user[0]))) {
          dispatch(emptyCart(cart));
          document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
          props.history.push("/login");
        }
        break;
      case "userInfo":
        setPanelPage("userInfo");
        break;
      case "reservedhistory":
        setPanelPage("reservedhistory");
        // setPanelData(orderHistory);
        break;
      case "userFavorites":
        setPanelPage("userFavorites");
        setPanelData([
          {
            id: 1,
            image: salonImage,
            salonTitle: "سالن زیبایی شبنم",
            salonAddress: "تهران،تهران پارس،خیابان قلی زاده، بن بست زیاری پلاک 60",
            salonSuport: "021-8866593",
            salonPhone: "021-8866593",
            rate: 3.5,
          },
          {
            id: 2,
            image: salonImage,
            salonTitle: "سالن زیبایی شبنم",
            salonAddress: "تهران،تهران پارس،خیابان قلی زاده، بن بست زیاری پلاک 60",
            salonSuport: "021-8866593",
            salonPhone: "021-8866593",
            rate: 4.5,
          },
        ]);
        break;
      case "changePassword":
        setPanelPage("changePassword");
        // props.history.push({
        //   pathname: "/changePasswordByCode",
        //   state: { changePass: true },
        // });
        break;
      case "changeBasePassword":
        setPanelPage("changeBasePassword");
        // props.history.push("/changePassword");
        break;
      default:
        break;
    }
  };

  const reservedHistoryAction = () => {
    console.log("Run History Action");
  };

  return (
    <div className="profileWrapper">
      <div className="desktop">
        <div className="profileItems">
          <ProfileSideBar oilQuota={oilQuota} data={profileImage} action={sideBarActions} />
          <ProfilePanel
            data={panelData}
            page={panelPage}
            orderHistory={orderHistory}
            reservedHistoryAction={reservedHistoryAction}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(withRouter(Profile));
